<template>
    <div>
        <div class="frame" id="page-header">
            <div class="identity" onclick="document.location.href ='/'">
                <span class="name">Dave Cook</span>
                <hr />
                <p>Software Solutions Engineer</p>
            </div>

            <div class="badges">
                <div class="badge">
                    <img src="/shared/images/badges/MCSD-RGB.gif" class="half-height-badge" alt="Microsoft Certified Solution Developer (MCSD)" title="Microsoft Certified Solution Developer (MCSD)" />
                </div>
                <div class="badge">
                    <a href="https://learn.microsoft.com/api/credentials/share/en-us/DaveCook-1227/C50CF6D81063D33?sharingId=797380306013C24E" target="_blank">
                        <img src="/shared/images/badges/azure-developer-associate-600x600.png" class="full-size-badge" alt="Certified Azure Developer Associate" title="Certified Azure Developer Associate" />
                    </a>
                </div>
                <div class="badge">
                    <a href="https://learn.microsoft.com/api/credentials/share/en-us/DaveCook-1227/5DFF330BD784522B?sharingId=797380306013C24E" target="_blank">
                        <img src="/shared/images/badges/devops-engineer-expert-600x600.png" class="full-size-badge" alt="Certified Azure DevOps Expert" title="Certified Azure DevOps Expert" />
                    </a>
                </div>
            </div>

        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-property-decorator';

    @Component
    export default class PageHeader extends Vue {
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .full-size-badge {
        width:100px;
        height:100px
    }

    .half-height-badge {
        width: 100px;
        height: 50px
    }

    p {
        padding-left: 3px;
        font-size: 1em;
        margin-top: -10px;
    }

    .frame{
        padding-left:10px;
    }

    .identity {
        float: left;
        vertical-align: middle;
        cursor: pointer;
    }

    .identity .name {
        font-size: 3em;
        margin-bottom: 0;
    }

    hr {
        margin-top: -5px;
        height: 2px;
        background-image: linear-gradient(to right, yellow, red, yellow, red)
    }

    .badges {
        float: right;
        margin-bottom: 10px;
    }

    .badge {
        vertical-align: middle;
        text-align: center;
        display: table-cell;
        padding-right: 10px;
    }
    @media screen and (max-width: 800px) {
        .badge {
            padding-right: 8px;
        }

        .full-size-badge {
            width: 75px;
            height: 75px
        }

        .half-height-badge {
            width: 75px;
            height: 37.5px
        }

        .identity .name {
            font-size: 2.3em;
            margin-bottom: 0;
        }

        p {
            padding-left: 2px;
            font-size: 0.9em;
        }

    }

    @media screen and (max-width: 600px) {
        .badge {
            padding-right: 6px;
        }

        .full-size-badge {
            width: 48px;
            height: 48px
        }

        .half-height-badge {
            width: 48px;
            height: 24px
        }

        .identity .name {
            font-size: 2.1em;
            margin-bottom: 0;
        }

        p {
            padding-left: 2px;
            font-size: 0.8em;
        }
    }

    @media screen and (max-width: 400px) {
        .badge {
            padding-right: 4px;
        }

        .full-size-badge {
            width: 30px;
            height: 30px
        }

        .half-height-badge {
            width: 30px;
            height: 15px
        }

        .identity .name {
            font-size: 1.8em;
            margin-bottom: 0;
        }

        p {
            margin-top: -10px;
            padding-left: 2px;
            font-size: 0.6em;
        }
    }


</style>
